import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import GoodbyeSrc from "shared/assets/images/goodbye-mate.png";

const HeroGoodbye: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Hero.S4A_HERO_GOODBYE,
    });
  }, []);

  return (
    <div className="greetings full-height">
      <div
        className="background-colors"
        style={{
          backgroundImage: `url(${GoodbyeSrc})`,
          backgroundSize: "100%",
        }}
      >
        <div style={{ padding: "0 40px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
            }}
            className="height-100"
          >
            <h1 className="blue-title">{t("pages.StrmHero.goodLuck")}</h1>
            <p className="body-regular" style={{ fontSize: 16 }}>
              <Trans
                i18nKey="pages.StrmHero.ifChangeMind"
                components={{
                  a: <a href="http://www.strmmusic.ai"> </a>,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroGoodbye;
